/**
 * `MMM d, yyyy h:mm a`, pinned to en-US 12-hour like Autodesk Assistant's
 * `utils/dateFormat.ts`. Split in two because one formatter with both date and
 * time parts inserts an "at" that no option removes.
 */
const DATE_PART = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

const TIME_PART = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

/** "Aug 25, 2026 10:42 AM", or '' if the input is missing or unparseable. */
export const formatMessageTimestamp = (isoTimestamp?: string): string => {
  if (!isoTimestamp) return '';

  const date = new Date(isoTimestamp);
  if (Number.isNaN(date.getTime())) return '';

  // Newer ICU uses U+202F before the meridiem; keep the output plain ASCII.
  return `${DATE_PART.format(date)} ${TIME_PART.format(date)}`.replace(
    /\u202f/g,
    ' ',
  );
};
